import { render } from "./EmployeeRejectedLiquidations.vue?vue&type=template&id=b041977a"
import script from "./EmployeeRejectedLiquidations.vue?vue&type=script&lang=js"
export * from "./EmployeeRejectedLiquidations.vue?vue&type=script&lang=js"

import "./EmployeeRejectedLiquidations.vue?vue&type=style&index=0&id=b041977a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__